module.exports = __webpack_public_path__ + "img/blog-2.06a8705d.jpg";